import { Rectangle } from 'recharts';
import type { ComponentProps } from 'react';

import { CHART_DIMENSIONS } from '../shared/chart-tokens';
import { colorForBar } from '../shared/chart-palette';

type RectangleProps = ComponentProps<typeof Rectangle>;

export interface BarChartBarProps extends RectangleProps {
  value?: number | null;
  seriesIndex: number;
  seriesCount: number;
}

// [r, r, 0, 0] rounds the value-end corners for both positive and negative
// bars because Recharts inverts path traversal for negative heights.
const BAR_RADIUS: [number, number, number, number] = [
  CHART_DIMENSIONS.barCornerRadius,
  CHART_DIMENSIONS.barCornerRadius,
  0,
  0,
];

export const BarChartBar = (props: BarChartBarProps) => {
  const { value, seriesIndex, seriesCount, ...rectangleProps } = props;
  const { width, height } = rectangleProps;

  if (
    value == null ||
    width === undefined ||
    height === undefined ||
    width === 0 ||
    height === 0
  ) {
    return null;
  }

  const fill = colorForBar(seriesIndex, seriesCount, value);

  return <Rectangle {...rectangleProps} fill={fill} radius={BAR_RADIUS} />;
};
